export default function titleToCamelCase(string) {
    return string.charAt(0).toLowerCase() + string.substring(1);
}
